import Content from "./Content";

export default class ChatContent extends Content {
    /**
     * @param {*} languagePack 
     * @param {*} contentID 
     * @param {string} npcId 
     * @param {string} chatDialogId 
     * @param {*} label 
     */
    constructor(languagePack, contentID, npcId, chatDialogId, label) {
        super(ChatContent.NAME, ChatContent.TYPE, label, languagePack, contentID);

        this._npcId = npcId;
        this._chatDialogId = chatDialogId;
    }

    getNpcId() {
        return this._npcId;
    }

    setNpcId(value) {
        this._npcId = value;
    }

    getChatDialogId() {
        return this._chatDialogId;
    }

    setChatDialogId(value) {
        this._chatDialogId = value;
    }

    clone() {
        var clone = new ChatContent(this._languagePack, null, null, null, this.getLabel());
        clone.setContentID(this.getContentID());

        clone.setNpcId(this.getNpcId());
        clone.setChatDialogId(this.getChatDialogId());

        return clone;
    }
    remove() {
        this.setNpcId(null);
        this.setChatDialogId(null);

        super.remove();
    }
    convertToObject() {
        return this.getObject(["npcId", "chatDialogId"]);
    }
}

ChatContent.NAME = "Chat";
ChatContent.TYPE = "engChatContent";